import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	stroke: "#fa8c16",
	strokeWidth: 1.5,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M12 2.251v-1.5m6.364 4.137l1.061-1.061M21 11.251h1.5m-4.136 6.364l1.061 1.061M5.636 4.888L4.575 3.827M3 11.251H1.5m4.136 6.364l-1.061 1.061M9 16.449v2.3a3 3 0 1 0 6 0v-2.3",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 17.251a6 6 0 1 0 0-12 6 6 0 1 0 0 12z",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 21.751v1.5",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224%22%20height%3D%2224%22%20fill%3D%22none%22%20stroke%3D%22%23fa8c16%22%20stroke-width%3D%221.5%22%3E%3Cpath%20d%3D%22M12%202.251v-1.5m6.364%204.137l1.061-1.061M21%2011.251h1.5m-4.136%206.364l1.061%201.061M5.636%204.888L4.575%203.827M3%2011.251H1.5m4.136%206.364l-1.061%201.061M9%2016.449v2.3a3%203%200%201%200%206%200v-2.3%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M12%2017.251a6%206%200%201%200%200-12%206%206%200%201%200%200%2012z%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M12%2021.751v1.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E";
